export default __webpack_public_path__ + "static/media/hipbaby_logo_vertical_clear.c85f0845.png";